import { Box, Typography } from '@mui/joy';
import { ArrowCounterClockwise, TrashSimple } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';
import { useMemo } from 'react';
import { useFieldArray } from 'react-hook-form';

import { ElementType } from 'bom/enums';
import { useAgGridClientTableContext, useFormContext } from 'core/states';
import { Color, Level } from 'theme/enums';

export const ActionsCell = ({ data, node }: ICellRendererParams) => {
  const { updateRows } = useAgGridClientTableContext();

  const { control } = useFormContext();

  const { update, remove } = useFieldArray({
    control,
    name: 'elements',
  });

  const isRowDeleteable = useMemo(
    () =>
      ![ElementType.ID_OVERAGE, ElementType.ID_SHORTAGE].includes(
        data?.element?.id as ElementType
      ) && !data?.deleted,
    [data]
  );

  const isRowRestorable = useMemo(() => data?.deleted, [data]);

  const handleRemove = () => {
    if (!data?.isNew) {
      const newRemovedElement = { ...data, deleted: true };

      update(node.rowIndex, newRemovedElement);
      updateRows({ update: [newRemovedElement] });

      return;
    }

    remove(node.rowIndex);
    updateRows({ remove: [data] }, { redrawRows: true });
  };

  const handleRestore = () => {
    const newRestoredElement = { ...data, deleted: false };

    update(node.rowIndex, newRestoredElement);
    updateRows({ update: [newRestoredElement] }, { redrawRows: true });
  };

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      {isRowDeleteable && (
        <Typography
          color={Color.DANGER}
          level={Level.BODY_SM}
          onClick={handleRemove}
          sx={{ cursor: 'pointer' }}
        >
          <TrashSimple />
        </Typography>
      )}

      {isRowRestorable && (
        <Typography
          color={Color.SUCCESS}
          level={Level.BODY_SM}
          onClick={handleRestore}
          sx={{ cursor: 'pointer' }}
        >
          <ArrowCounterClockwise />
        </Typography>
      )}
    </Box>
  );
};
